import { render, staticRenderFns } from "./invoice-success.vue?vue&type=template&id=71bdb48e&scoped=true"
import script from "./invoice-success.vue?vue&type=script&lang=js"
export * from "./invoice-success.vue?vue&type=script&lang=js"
import style0 from "./invoice-success.vue?vue&type=style&index=0&id=71bdb48e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdb48e",
  null
  
)

export default component.exports